import { tokens } from '@cellula/react-theme-patient';
import { Outlet } from 'react-router';
import styled from 'styled-components';

const StyledWebsiteTextPage = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 800px;
	margin: 0 auto;
	width: 100%;
	padding: ${tokens.spacing.x3} ${tokens.spacing.x2};

	${tokens.breakpointQuery.medium} {
		padding: ${tokens.spacing.x4} ${tokens.spacing.x4};
	}
`;

export function LayoutOutletTextPage() {
	return (
		<StyledWebsiteTextPage>
			<Outlet />
		</StyledWebsiteTextPage>
	);
}
